import { gql } from "@apollo/client";

import { EMERSON_PRODUCT_SEARCH_RESULT } from "@emerson/data/splinters/EmersonProductSearchResult.fragment";
import { EMERSON_PRODUCT_SEARCH_RESULT_OPEN } from "@emerson/data/splinters/EmersonProductSearchResultOpen.fragment";

const SimilarProducts_Emerson_Query = gql`
  query SimilarProducts_Emerson_Query(
    $productId: ID!
    $first: Int
    $isUnauthenticated: Boolean = false
  ) {
    viewer {
      product: node(id: $productId) {
        ... on Product {
          id
          similarProducts(first: $first) {
            nodes {
              ...EmersonProductSearchResult @skip(if: $isUnauthenticated)
              ...EmersonProductSearchResultOpen @include(if: $isUnauthenticated)
            }
          }
        }
      }
    }
  }
  ${EMERSON_PRODUCT_SEARCH_RESULT}
  ${EMERSON_PRODUCT_SEARCH_RESULT_OPEN}
`;

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { SimilarProducts_Emerson_Query };
